import React, { Component } from "react";
import Header from "./header";
import { MdArrowUpward } from "react-icons/md";
import TransactionValidation from "./transactions_validation";
import SearchValidation from "./validation_search";
import Swal from "sweetalert2";
import io from "socket.io-client";
import jwt_decode from "jwt-decode";
const url = "https://transacoes-api.all.com.br:3080";

class Validation extends Component {
  state = {
    idEmployeeLogged: "",
    userEmail: "",
    loading: true,
    filter: "requester",
    filteredContent: false,
    selectedContentTransaction: [],
    transactions: [],
    movements: [],
    searchValue: "",
    items: []
  };

  socket = io(url);

  async componentDidMount() {
    this.eventListenerSocket();
    this.loadInstructions();
    await this.getUserLogged();
    this.getData();
  }

  getData = () => {
    this.getTransaction();
    this.getMovement();
    this.getItems();
    this.getEmployee();
  };

  eventListenerSocket = () => {
    this.socket.on("data", () => this.getData());
  };

  loadInstructions = () => {
    const Toast = Swal.mixin({
      toast: true,
      position: window.innerWidth <= "475" ? "top-start" : "top",
      showConfirmButton: false,
      timer: 5000
    });

    Toast.fire({
      type: "info",
      title: "Gerência:",
      text:
        "Visualização dos envios de acordo com perfil do usuário e status do malote."
    });
  };

  getUserLogged = async () => {
    if (localStorage.getItem("token") !== null) {
      const userToken = JSON.parse(localStorage.getItem("token").toString());
      let decoded = jwt_decode(userToken.token);
      await this.setState({
        idEmployeeLogged: decoded.id.toString(),
        userEmail: decoded.email
      });
    } else
      this.setState({
        idEmployeeLogged: "",
        userEmail: ""
      });
  };

  setTransaction = url => {
    fetch(url)
      .then(response => response.json())
      .then(transaction => {
        this.setState({
          transactions: transaction,
          loading: false
        });
      });
    this.setState({ transactions: [], loading: false });
  };

  getTransaction = () => {
    if (this.state.filter === "requester") {
      if (this.state.searchValue === "ativa") {
        this.setTransaction(
          `${url}/solicitante/transacoes_ativas/${this.state.idEmployeeLogged}`
        );
      } else if (this.state.searchValue === "pendente") {
        this.setTransaction(
          `${url}/solicitante/transacoes_pendentes/${this.state.idEmployeeLogged}`
        );
      } else if (this.state.searchValue === "concluida") {
        this.setTransaction(
          `${url}/solicitante/transacoes_concluidas/${this.state.idEmployeeLogged}`
        );
      } else {
        this.setTransaction(
          `${url}/solicitante/transacoes/${this.state.idEmployeeLogged}`
        );
      }
    } else if (this.state.filter === "requested") {
      if (this.state.searchValue === "ativa") {
        this.setTransaction(
          `${url}/solicitado/transacoes_ativas/${this.state.idEmployeeLogged}`
        );
      } else if (this.state.searchValue === "pendente") {
        this.setTransaction(
          `${url}/solicitado/transacoes_pendentes/${this.state.idEmployeeLogged}`
        );
      } else if (this.state.searchValue === "concluida") {
        this.setTransaction(
          `${url}/solicitado/transacoes_concluidas/${this.state.idEmployeeLogged}`
        );
      } else {
        this.setTransaction(
          `${url}/solicitado/transacoes/${this.state.idEmployeeLogged}`
        );
      }
    }
  };

  getMovement = () => {
    if (this.state.filter === "requester") {
      fetch(`${url}/solicitante/movimentacoes/${this.state.idEmployeeLogged}`)
        .then(response => response.json())
        .then(movement => {
          if (movement.length) {
            this.setState({ movements: movement, loading: false });
          } else {
            this.setState({ movements: [], loading: false });
          }
        });
    } else if (this.state.filter === "requested") {
      fetch(`${url}/solicitado/movimentacoes/${this.state.idEmployeeLogged}`)
        .then(response => response.json())
        .then(movement => {
          if (movement.length) {
            this.setState({ movements: movement, loading: false });
          } else {
            this.setState({ movements: [], loading: false });
          }
        });
    }
  };

  getItems = () => {
    if (this.state.filter === "requester") {
      fetch(`${url}/solicitante/itens/${this.state.idEmployeeLogged}`)
        .then(response => response.json())
        .then(item => {
          if (item.length) {
            this.setState({ items: item, loading: false });
          } else {
            this.setState({ items: [], loading: false });
          }
        });
    } else if (this.state.filter === "requested") {
      fetch(`${url}/solicitado/itens/${this.state.idEmployeeLogged}`)
        .then(response => response.json())
        .then(item => {
          if (item.length) {
            this.setState({ items: item, loading: false });
          } else {
            this.setState({ items: [], loading: false });
          }
        });
    }
  };

  getEmployee = () => {
    fetch(`${url}/funcionarios`)
      .then(response => response.json())
      .then(employee => {
        this.setState({
          employees: employee,
          loading: false
        });
      });
    this.setState({ employees: [], loading: false });
  };

  scrollTop = () => {
    window.scrollTo(0, 0);
  };

  handleSearch = async value => {
    await this.setState({ searchValue: value });
    this.getData();
    await this.filterContentSearch(value);
  };

  handleFilter = async filter => {
    await this.setState({
      filter: filter,
      searchValue: "",
      selectedContentTransaction: [],
      filteredContent: false
    });
    this.getData();
  };

  filterContentSearch = value => {
    let selectContentTransaction = [];
    if (this.state.transactions.length > 0) {
      selectContentTransaction = this.state.transactions.filter(transaction =>
        transaction.status.toLowerCase().includes(value.toLowerCase())
      );
      this.setState({
        selectedContentTransaction:
          selectContentTransaction.length > 0 ? selectContentTransaction : false
      });
      this.setState({ filteredContent: true });
    } else {
      this.setState({ filteredContent: false });
    }
  };

  filterMovements = () => {
    let selectContentItem = this.state.items.filter(item => item.status !== 4);
    let i = 0,
      j = 0,
      selectContentItemLength = selectContentItem.length;
    let findMovement = [];
    for (i = 0; i < this.state.movements.length; ++i) {
      for (j = 0; j < selectContentItemLength; ++j) {
        if (this.state.movements[i].id_item === selectContentItem[j].id_item) {
          findMovement[i] = this.state.movements[i];
        }
      }
    }
    return findMovement;
  };

  render() {
    const {
      selectedContentTransaction,
      transactions,
      movements,
      employees,
      items,
      loading
    } = this.state;
    return (
      <React.Fragment>
        <Header title={"Gerência"} activeNavContent={true} />
        <div
          className="search"
          style={{
            float: "center",
            margin: "auto",
            width: "100%",
            display: "block",
            position: "fixed",
            zIndex: "10"
          }}
        >
          <SearchValidation
            handleSearch={value => this.handleSearch(value)}
            handleFilter={filter => this.handleFilter(filter)}
          />
        </div>
        {loading && (
          <div
            className="preloader-wrapper big active"
            style={{
              display: "block",
              margin: "auto",
              float: "center",
              marginTop: "200px"
            }}
          >
            <div className="spinner-layer spinner-red-only">
              <div className="circle-clipper left">
                <div className="circle" />
              </div>
              <div className="gap-patch">
                <div className="circle" />
              </div>
              <div className="circle-clipper right">
                <div className="circle" />
              </div>
            </div>
          </div>
        )}
        {!loading && (
          <center>
            <TransactionValidation
              selectedContentTransaction={
                transactions.length > 0 &&
                selectedContentTransaction.length === 0
                  ? true
                  : selectedContentTransaction
              }
              transactions={transactions.length > 0 && transactions}
              //hidden movements canceled
              movements={
                this.state.filter === "requester"
                  ? this.state.searchValue === "concluida"
                    ? movements.length > 0 && movements
                    : movements.length > 0 && this.filterMovements()
                  : movements.length > 0 && movements
              }
              //hidden items canceled
              items={
                this.state.filter === "requester"
                  ? this.state.searchValue === "concluida"
                    ? items.length > 0 && items
                    : items.length > 0 &&
                      items.filter(item => item.status !== 4)
                  : items.length > 0 && items
              }
              employees={employees && employees}
              filter={this.state.filter && this.state.filter}
              searchValue={this.state.searchValue && this.state.searchValue}
              userEmail={this.state.userEmail && this.state.userEmail}
              idEmployeeLogged={
                this.state.idEmployeeLogged && this.state.idEmployeeLogged
              }
            />
            <a
              disabled={transactions.length > 0 ? false : true}
              href="#up"
              className="btn-floating btn-large halfway-fab waves-effect waves-light"
              style={{
                position: "fixed",
                display: "block",
                margin: "auto",
                bottom: "20px",
                right: "7px",
                backgroundColor: "#357ae8"
              }}
              onClick={() => this.scrollTop()}
            >
              <i className="material-icons">
                <MdArrowUpward />
              </i>
            </a>
          </center>
        )}
      </React.Fragment>
    );
  }
}

export default Validation;
